import React from 'react';
import { MagnifyingGlass, X } from 'phosphor-react';

interface SearchFieldProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  placeholder = "Buscar",
  value,
  onChange,
  onClear,
  onKeyDown,
  autoFocus,
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else if (onChange) {
      const event = {
        target: { value: '' }
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (onKeyDown) {
      onKeyDown(e);
      if (e.defaultPrevented) return;
    }
    if (e.key === 'Escape') {
      handleClear();
    }
  };

  return (
    <div 
      className="flex gap-2 items-center px-2 rounded-full w-full"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)', height: '40px' }}
      data-name="search field" 
      data-node-id="1:149"
    >
      <div className="relative shrink-0 w-4 h-4" data-name="Frame" data-node-id="1:150">
        <MagnifyingGlass size={16} weight="bold" color="#646660" style={{ width: '16px', height: '16px', display: 'block', flexShrink: 0 }} />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        autoFocus={autoFocus}
        className="flex-1 font-sans font-medium text-base text-text-subtle tracking-[-0.14px] bg-transparent border-none outline-none"
        data-node-id="1:152"
      />
      {value && (
        <button
          onClick={handleClear}
          className="shrink-0 w-4 h-4 flex items-center justify-center cursor-pointer"
          aria-label="Clear search"
          type="button"
        >
          <X size={16} weight="bold" color="#646660" style={{ width: '16px', height: '16px', display: 'block', flexShrink: 0 }} />
        </button>
      )}
    </div>
  );
};

export default SearchField;

